






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Frame extends Vue {
  @Prop(Array) list!: Array<string>;
  @Prop(Boolean) start!: Boolean;
  @Prop(Boolean) center!: Boolean;
  @Prop(Function) complete?: Function;
  @Prop(Boolean) loop!: Boolean;

  current: number = 0;
  timer: number | undefined = 0;

  @Watch('start', { immediate: true })
  onChangeValue(t: boolean) {
    if (t) {
      this.timer = setInterval(() => {
        // console.log(this.current);

        if (this.current == this.list.length - 1) {
          if (this.loop) {
            this.current = -1;
          } else {
            // over
            clearInterval(this.timer);

            this.complete && this.complete();
            return;
          }
        }
        this.current++;
      }, 1e3 / 15);
    }
  }

  destroyed() {
    console.log(`frame destroyed`);

    clearInterval(this.timer);
  }
}
